import { Button, message, Tooltip } from 'antd';
import { SyncOutlined, LoadingOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { useEffect, useRef } from 'react';
import { eventBus } from 'services/eventBus';
import { useMemoizedFn, useRequest } from 'ahooks';
import { refreshReturnList } from 'services/api/refund';

export const SyncButton = () => {
  const { t } = useTranslate();
  const internalReturnIdRef = useRef<string[]>([]);
  const { loading, runAsync: syncList } = useRequest((list: string[]) => refreshReturnList(list), {
    manual: true,
    onSuccess() {
      message.success(t('操作成功'));
    },
    onError() {
      message.error(t('translation.操作失败，请稍后再试'));
    },
  });

  const handleClick = useMemoizedFn(() => {
    if (internalReturnIdRef.current) {
      syncList(internalReturnIdRef.current);
    }
  });

  useEffect(() => {
    const handler = (internalReturnId: string[]) => {
      internalReturnIdRef.current = internalReturnId;
    };
    eventBus.on('RETURN_LIST_ID_SYNC', handler);
    return () => {
      eventBus.off('RETURN_LIST_ID_SYNC', handler);
    };
  }, [syncList]);

  return (
    <Tooltip title={t('每20分钟自动同步一次')}>
      <Button
        disabled={loading}
        icon={loading ? <LoadingOutlined /> : <SyncOutlined />}
        onClick={handleClick}
      >
        {t('同步')}
      </Button>
    </Tooltip>
  );
};
